import { translateText } from "../../../helpers/LanguageHelper";
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Config from '../../../helpers/Config';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import { Media, Row, Col, Container } from "reactstrap";
import aboutImg from '../../../resources/custom/images/about-us.jpg';
import aboutImg_scond from '../../../resources/custom/images/about_second_image.jpg';

import CustomerTestimonial from '../../components/shared/CustomerTestimonial';

const About = () => {
  const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);

  return (
    <>


      <Helmet>
        <title>{siteTitle}{translateText(" - About Us")}</title>
        <meta name="description" content={siteTitle + " - About us page"}  />
        <meta name="keywords" content="About us, Uthukuli butter online, Buy Uthukuli butter, Traditional butter Tamil Nadu, Desi butter online India,UKL Butter, dairy products, fresh butter"></meta>
      </Helmet>

      <SiteBreadcrumb title={translateText("About-Us")} parent="Home"/>

      <section className="about-page section-big-py-space">
        <div className="custom-container">
          <Row>
            <Col lg="6">
              <div className="banner-section">
                <Media src={aboutImg} className="img-fluid w-100" alt="" />
              </div>
            </Col>
            <Col lg="6">
             
              <p className="mb-2">
                {" "}{translateText("Welcome to ")}<b>{translateText("UKL Butter")}</b>{translateText(", proudly made in Uthukuli!")}</p>
              <p className="mb-2">
                {" "}{translateText("We are a family of farmers from Uthukuli, a small town in Tamil Nadu, India. On our family-run farm, we produce high-quality butter celebrated for its rich flavor and creamy texture")}</p>
              <p className="mb-2">
                {" "}{translateText("The unique qualities of our butter originate from Uthukuli’s rich dairy farming heritage. Cows and buffaloes in the region are fed a wholesome diet of maize stalks, bran, and oilcake, producing milk that is naturally high in fat and full of flavor.")}</p>
              <p className="mb-2">
                {" "}{translateText("Unlike other types of butter, Uthukuli butter has a slightly tangy flavor and a matte finish. Its impressive shelf life.lasting up to a month at room temperature.speaks to its purity and the traditional methods used in its production.")}</p>
              
            </Col>
          </Row>
          <Row>
            <Col lg="6">
           
              <p className="mb-2">
                {" "}<br></br>{translateText("Uthukuli buffaloes are famous primarily because of the exceptional quality of milk they produce, which plays a key role in the region's renowned butter and ghee production.")}</p>
              
              <p className="mb-2">
                {" "}{translateText("The \"Uthukuli butter\" brand is recognized across Tamil Nadu and India for its purity and traditional quality, thanks in large part to these buffaloes.")}</p>
              <p className="mb-2">
                {" "}{translateText("We have started small initiative to reach you. Not for Profit it is all about health and original product.")}</p>
            </Col>
            <Col lg="6">
            <div className="banner-section">
                <Media src={aboutImg_scond} className="img-fluid w-100" alt="" />
              </div>
              
            </Col>
          </Row>
        </div>
      </section>

      <CustomerTestimonial />

    </>
  );

}

export default About;
